import { MessageSquare } from "lucide-react";
import { Reveal } from "@/components/motion";

export const Community = () => (
  <section className="border-t border-white/10" data-testid="community">
    <div className="px-6 sm:px-12 lg:px-20 py-20 max-w-[1400px] mx-auto flex flex-col md:flex-row md:items-center gap-8 md:gap-16">
      <Reveal className="flex-1">
        <p className="label-mono mb-4 flex items-center gap-3">
          <span className="inline-block w-8 h-px bg-[#FF3B00]" /> 04 — Community
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl leading-[0.95]">
          The workshop <span className="text-[#FF3B00]">forum.</span>
        </h2>
        <p className="mt-5 max-w-lg text-white/70 leading-relaxed">
          Registered members only: ask for help, answer each other, and suggest what gets
          built next. Your confirmed email is your key.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <a href="/forum" className="btn-ghost" data-testid="community-forum-link">
          <MessageSquare className="w-4 h-4" /> Visit the forum
        </a>
      </Reveal>
    </div>
  </section>
);
